import { Box } from "@mui/material";
import type { ReactNode } from "react";
import type { SxProps, Theme } from "@mui/material";
import { layout } from "../styles/tokens";

interface PageSectionProps {
  children: ReactNode;
  bg?: string;
  sx?: SxProps<Theme>;
}

function PageSection({
  children,
  bg = "background.default",
  sx = {},
}: PageSectionProps) {
  return (
    <Box
      sx={{
        py: layout.sectionPaddingY,
        bgcolor: bg,
        ...sx,
      }}
    >
      {children}
    </Box>
  );
}

export default PageSection;
